export const GET_USER_INFO_REQUEST = 'GET_USER_INFO_REQUEST'
export const GET_USER_INFO_FAILURE = 'GET_USER_INFO_FAILURE'
export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS'
export const UPDATE_USER_INFO_REQUEST = 'UPDATE_USER_INFO_REQUEST'
export const UPDATE_USER_INFO_FAILURE = 'UPDATE_USER_INFO_FAILURE'
export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS'
export const RESET_USER_INFO_REQUEST = 'RESET_USER_INFO_REQUEST'
